import React from 'react'
import { Navigate } from 'react-router-dom'

import useAuthenticate from 'hooks/use-authenticate'
import { ValidPermission } from 'types/global'
import ErrorBoundary from 'modules/ErrorBoundary'
import { ROUTES, ROUTE_BASE } from '../../constants/constants'

type RouteGuardProps = {
  children: React.ReactNode
  redirectTo?: string
  requiredPermissions?: ValidPermission[]
  requiresAuthentication?: boolean
  withErrorBoundary?: boolean
  withPermission?: boolean
  errorBoundaryWithNavBar?: boolean
}

const RouteGuard = ({
  children,
  redirectTo,
  requiredPermissions,
  requiresAuthentication = true,
  withErrorBoundary = true,
  withPermission,
  errorBoundaryWithNavBar = true,
}: RouteGuardProps) => {
  const { isAuthenticated } = useAuthenticate()

  const hasPermission = withPermission !== undefined ? withPermission : !requiredPermissions

  if (requiresAuthentication && !isAuthenticated) {
    return <Navigate to={`/${ROUTE_BASE.AUTH}/${ROUTES.LOGIN}`} state={{ from: window.location.pathname }} replace />
  }

  if (!hasPermission) {
    return <Navigate to={redirectTo || ROUTES.HOME} replace />
  }

  const content = <>{children}</>
  return withErrorBoundary ? <ErrorBoundary hasToken={errorBoundaryWithNavBar}>{content}</ErrorBoundary> : content
}

export default RouteGuard
